"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  downloadAll: 'Download all',
  previousFile: 'Previous',
  nextFile: 'Next'
};